<template>
  <div class="project-details" :class="{'project-opertion':isFlag === 3}">
    <el-form
      class="project-details-from"
      :rules="projectBaseInfoFromRules"
      ref="projectBaseInfoFrom"
      :model="projectBaseInfoFrom"
      label-width="100px"
    >
      <div class="project-details-createTime" v-if="isFlag === 3">
        <span>创建时间：{{ projectBaseInfoFrom.createTime }}</span>
      </div>
      <div class="token" v-if="isFlag === 3">
        <span>水晶Token：{{ projectBaseInfoFrom.projectToken }}</span>
        <img class="copy" src="~assets/images/copy.png" @click="copyText">
      </div>
      <el-form-item label="客户名称" prop="customerId">
        <el-select
          filterable
          v-model="projectBaseInfoFrom.customerId"
          placeholder="请选择客户"
          :disabled="isFlag === 3? true:false"
        >
          <el-option
            v-for="item in customerList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="项目名称" prop="projectName">
        <el-input
          v-model="projectBaseInfoFrom.projectName"
          placeholder="请输入项目名称"
          :disabled="isFlag === 3? true:false"
        ></el-input>
      </el-form-item>
      <el-form-item label="负责人" prop="head">
        <el-select
          v-model="projectBaseInfoFrom.head"
          placeholder="请选择负责人"
          :disabled="isFlag === 3? true:false"
        >
          <el-option
            v-for="item in headList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="税率" prop="taxRate">
        <el-input
          @input="taxRateInput"
          v-model="projectBaseInfoFrom.taxRate"
          placeholder="示例：税率6%，填写0.06"
          :disabled="isFlag === 3"
        ></el-input>
      </el-form-item>
      <el-form-item label="物流税率" prop="logisticTaxRate">
        <el-input
          @input="logisticTaxRateInput"
          v-model="projectBaseInfoFrom.logisticTaxRate"
          placeholder="示例：税率6%，填写0.06"
          :disabled="isFlag === 3"
        ></el-input>
      </el-form-item>
      <el-form-item label="合同时间" prop="date">
        <el-date-picker
          v-model="projectBaseInfoFrom.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :disabled="isFlag === 3? true:false"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="数据来源" prop="dataSource">
        <el-select
          v-model="projectBaseInfoFrom.dataSource"
          placeholder="请选择数据来源"
          :disabled="isFlag === 3? true:false"
        >
          <el-option
            v-for="item in dataSourceList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="合同面积" prop="contractArea">
        <span slot="label">
          <span>合同面积</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <div v-html="`保底面积，即当实占面积<br />低于合同面积时，以合同<br />面积计算场租`" slot="content" style="line-height: 18px;"></div>
            <img class="help-hign" src="~assets/images/help/help-hign.png">
          </el-tooltip>
        </span>
        <el-input
          @input="contractAreaInput"
          v-model="projectBaseInfoFrom.contractArea"
          placeholder="请输入合同面积"
          :disabled="isFlag === 3? true:false"
        ></el-input>
      </el-form-item>
      <el-form-item label="分摊面积" prop="shareArea">
        <el-input
          @input="shareAreaInput"
          v-model="projectBaseInfoFrom.shareArea"
          placeholder="请输入分摊面积"
          :disabled="isFlag === 3? true:false"
        ></el-input>
      </el-form-item>
      <el-form-item label="截单时间" prop="finalOrderTime" class="cut-time">
        <el-time-picker
          v-model="projectBaseInfoFrom.finalOrderTime"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
          :disabled="isFlag === 3? true:false"
          placeholder="请选择截单时间">
        </el-time-picker>
      </el-form-item>
      <el-form-item label="物流加收费" prop="logisticsInterceptChargeFlag">
        <span slot="label">
          <span>物流加收费</span>
          <el-tooltip class="item" effect="dark" placement="top">
            <div v-html="`当物流拦截不收费时，导入拦<br />截费用将不纳入月账单计算`" slot="content" style="line-height: 18px;"></div>
            <img class="help-hign" src="~assets/images/help/help-hign.png">
          </el-tooltip>
        </span>
        <el-select
          v-model="projectBaseInfoFrom.logisticsInterceptChargeFlag"
          placeholder="请选择"
          :disabled="isFlag === 3? true:false"
        >
          <el-option
            v-for="item in logisticsPlusChargesList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注" prop="remark">
        <el-input
          v-model="projectBaseInfoFrom.remark"
          type="textarea"
          class="white"
          placeholder="请输入"
          maxlength="100"
          show-word-limit
          :disabled="isFlag === 3 ? true : false"
        ></el-input>
      </el-form-item>
      <el-form-item label="项目简介" prop="projectsDesc">
        <el-input
          v-model="projectBaseInfoFrom.projectsDesc"
          type="textarea"
          class="white"
          placeholder="请输入"
          maxlength="500"
          show-word-limit
          :disabled="isFlag === 3 ? true : false"
        ></el-input>
      </el-form-item>
      
      <div class="switch-title">
        <p class="sub-title">综合保底</p>
        <el-switch
          class="custom-switch"
          active-color="#2E68EA"
          :disabled="isFlag === 3"
          v-model="projectBaseInfoFrom.hasOpenComprehensiveMinimumGuarantee"
          :active-text="projectBaseInfoFrom.hasOpenComprehensiveMinimumGuarantee?'开启保底':'关闭保底'"
        >
        </el-switch>
      </div>
      <div class="row-item" v-if="projectBaseInfoFrom.hasOpenComprehensiveMinimumGuarantee">
        <el-form-item label="综合保底" prop="comprehensiveMinimumGuaranteeAmount">
          <el-input
            class="select-minimum-guarantee"
            @input="comprehensiveMinimumGuaranteeAmountInput"
            v-model="projectBaseInfoFrom.comprehensiveMinimumGuaranteeAmount"
            placeholder="请输入"
            :disabled="isFlag === 3"
            :rules="[
              { required: projectBaseInfoFrom.hasOpenComprehensiveMinimumGuarantee ? true : false, message: '请输入综合保底', trigger: 'blur' }
            ]"
          >
            <span
              slot="suffix"
              >
                {{ projectBaseInfoFrom.comprehensiveMinimumGuaranteeType === 1?'元/m²/月':'元/月'}}
              </span
            >
          </el-input>
          <el-select
            class="w120"
            v-model="projectBaseInfoFrom.comprehensiveMinimumGuaranteeType"
            @change="changeComprehensiveMinimumGuaranteeType"
            :disabled="isFlag === 3"
          >
            <el-option
              v-for="item in comprehensiveMinimumGuaranteeList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否包含">
          <el-checkbox v-model="projectBaseInfoFrom.hasExtraFee" 
          :disabled="isFlag === 3">增值服务</el-checkbox>
          <el-checkbox v-model="projectBaseInfoFrom.hasCityMatching" 
          :disabled="isFlag === 3">市内配送</el-checkbox>
          <el-checkbox v-model="projectBaseInfoFrom.hasCancelOrder" 
          :disabled="isFlag === 3">订单取消</el-checkbox>
        </el-form-item>
      </div>
    </el-form>
    <div class="project-details-footer" v-if="isFlag === 2">
      <el-button class="btn-blue" @click="saveProjectBaseInfo('projectBaseInfoFrom')">保存</el-button>
    </div>
  </div>
</template>

<script>
import ProjectManage from "models/project-manage";
const projectManage = new ProjectManage();
import { getDecimal } from "common/js/util";
import customerMixins from "@/common/mixins/customer.js"
import projectManageMixins from "@/common/mixins/project-manage.js"
export default {
  mixins: [customerMixins, projectManageMixins],
  props: ['parentProjectBaseInfoFrom'],

  data() {
    return {
      isFlag: null,
      projectBaseInfoFrom: this.parentProjectBaseInfoFrom,
      logisticsPlusChargesList: [
        {id:1, name: '有'},
        {id:0, name: '无'}
      ],
      projectBaseInfoFromRules: {
        customerId: [
          { required: true, message: "请选择客户", trigger: "change" },
        ],
        projectName: [
          { required: true, message: "请输入项目名称", trigger: "blur" },
        ],
        head: [{ required: true, message: "请选择负责人", trigger: "change" }],
        dataSource: [
          { required: true, message: "请选择数据来源", trigger: "change" },
        ],
        shareArea: [
          { required: true, message: "请输入分摊面积", trigger: "blur" },
        ],
        logisticsInterceptChargeFlag: [
          { required: true, message: "请选择物流加收费", trigger: "change" },
        ],
        date: [
          { required: true, message: "请选择合同时间", trigger: "change" },
        ],
        logisticTaxRate: [
          { required: true, message: "请输入物流税率", trigger: "blur" },
        ],
        taxRate: [
          { required: true, message: "请输入税率", trigger: "blur" },
        ],
      }
    }
  },

  created() {
    this.$bus.on('getBaseInfoFrom', v => {
      this.projectBaseInfoFrom = v
    }) 
    this.isFlag = Number(this.$route.query.isFlag);
    this.initCustomerList();
    this.initHeadList()
  },

  methods: {
    saveProjectBaseInfo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let id = Number(this.$route.query.projectId);
          let customerId = this.projectBaseInfoFrom.customerId
          let projectsName = this.projectBaseInfoFrom.projectName
          let businessOwner1 = this.projectBaseInfoFrom.head
          let contractBeginTime =  this.projectBaseInfoFrom.date.length > 0 ? this.projectBaseInfoFrom.date[0]: '';
          let contractEndTime = this.projectBaseInfoFrom.date.length > 0 ? this.projectBaseInfoFrom.date[1]:'';
          let dataSource = this.projectBaseInfoFrom.dataSource;
          let logisticsInterceptChargeFlag = this.projectBaseInfoFrom.logisticsInterceptChargeFlag;
          let contractArea = this.projectBaseInfoFrom.contractArea;
          let shareArea = this.projectBaseInfoFrom.shareArea;
          let finalOrderTime = this.projectBaseInfoFrom.finalOrderTime;
          let logisticTaxRate = this.projectBaseInfoFrom.logisticTaxRate;
          let taxRate = this.projectBaseInfoFrom.taxRate;
          let remark = this.projectBaseInfoFrom.remark;
          let projectsDesc = this.projectBaseInfoFrom.projectsDesc;
          let baseGuaranteedRule = null
          let minimumFeeRule = {}
          // 综合保底
          if (this.projectBaseInfoFrom.hasOpenComprehensiveMinimumGuarantee) {
            baseGuaranteedRule = {}
            if (this.projectBaseInfoFrom.comprehensiveMinimumGuaranteeType === 1) {
              // 保底面积
              baseGuaranteedRule.ruleType = "area"
              baseGuaranteedRule.baseGuaranteedUnitPrice = this.projectBaseInfoFrom.comprehensiveMinimumGuaranteeAmount
            } else {
              // 保底金额
              baseGuaranteedRule.ruleType = "fee"
              baseGuaranteedRule.minimumFee = this.projectBaseInfoFrom.comprehensiveMinimumGuaranteeAmount
            }
            minimumFeeRule.hasExtraFee = this.projectBaseInfoFrom.hasExtraFee ? 1:0
            minimumFeeRule.hasCityMatching = this.projectBaseInfoFrom.hasCityMatching? 1:0
            minimumFeeRule.hasCancelOrder = this.projectBaseInfoFrom.hasCancelOrder ? 1:0
          } else {
            minimumFeeRule.hasExtraFee = 0
            minimumFeeRule.hasCityMatching = 0
            minimumFeeRule.hasCancelOrder = 0
          }
          let data = {
            id,
            customerId,
            projectsName,
            businessOwner1,
            contractBeginTime,
            contractEndTime,
            dataSource,
            logisticsInterceptChargeFlag,
            contractArea,
            shareArea,
            finalOrderTime,
            baseGuaranteedRule,
            logisticTaxRate,
            minimumFeeRule,
            taxRate,
            remark,
            projectsDesc
          }
          projectManage.postUpdateProject(data).then(res => {
            if (res.success) {
              this.$message({
                type: 'success',
                message: '基本信息编辑成功'
              })
            } else {
              this.$message({
                type: 'error',
                message: res.message
              })
            }
          })
        } else {
          console.log("error submit!!");
          return false;
        }
      })
    },
    copyText() {
      let oInput = document.createElement('input');
      oInput.value = this.projectBaseInfoFrom.projectToken;
      document.body.appendChild(oInput);
      oInput.select(); // 选择对象;
      document.execCommand("copy")
      this.$message.success('已复制')
      oInput.remove()
    },
    /* 实占面积 */
    useAreaInput() {
      let useArea = this.projectBaseInfoFrom.useArea;
      this.projectBaseInfoFrom.useArea = getDecimal(useArea);
    },
    /* 分摊面积 */
    shareAreaInput() {
      let shareArea = this.projectBaseInfoFrom.shareArea;
      this.projectBaseInfoFrom.shareArea = getDecimal(shareArea);
    },
    /* 合同面积 */
    contractAreaInput() {
      let contractArea = this.projectBaseInfoFrom.contractArea;
      this.projectBaseInfoFrom.contractArea = getDecimal(contractArea);
    },
    /** 
     * @desc 清空综合保底金额
    */
    changeComprehensiveMinimumGuaranteeType() {
      this.projectBaseInfoFrom.comprehensiveMinimumGuaranteeAmount = null
    },
    /** 
     * @desc 综合保底金额限制
    */
    comprehensiveMinimumGuaranteeAmountInput() {
      let comprehensiveMinimumGuaranteeAmount = this.projectBaseInfoFrom.comprehensiveMinimumGuaranteeAmount;
      this.projectBaseInfoFrom.comprehensiveMinimumGuaranteeAmount = getDecimal(
        comprehensiveMinimumGuaranteeAmount
      );
    },
    /* 限制物流税率 */
    logisticTaxRateInput() {
      let logisticTaxRate = this.projectBaseInfoFrom.logisticTaxRate;
      this.projectBaseInfoFrom.logisticTaxRate = getDecimal(logisticTaxRate);
    },
    /* 限制税率 */
    taxRateInput() {
      let taxRate = this.projectBaseInfoFrom.taxRate;
      this.projectBaseInfoFrom.taxRate = getDecimal(taxRate);
    },
  }
}
</script>

<style lang='scss'>
@import '@/assets/style/layout/project/project-details.scss';
</style>
